// extracted by mini-css-extract-plugin
export default {"root":"TrustIndicators-module-root","title":"TrustIndicators-module-title","trustIndicators":"TrustIndicators-module-trustIndicators"};